// ─────────────────────────────────────────────────────────────────────────────
// Shared "hotkey used" feedback contract for the live Desktop chrome. Any
// hotkey that mirrors a DesktopSystemBar button (window cycling, chat/sidebar
// toggles, search, new window, …) emits this DOM CustomEvent; DesktopSystemBar
// listens for it and renders a brief blue hint with a keycap that fades out
// fast — see useDesktopWindowCycleHotkey and useDesktopActionHotkeys.
// ─────────────────────────────────────────────────────────────────────────────

export const DESKTOP_HOTKEY_FEEDBACK_EVENT = 'desktop:hotkeyFeedback';

export interface DesktopHotkeyFeedbackDetail {
  label: string;
  keys: string[];
}

export function emitDesktopHotkeyFeedback(detail: DesktopHotkeyFeedbackDetail): void {
  window.dispatchEvent(
    new CustomEvent<DesktopHotkeyFeedbackDetail>(DESKTOP_HOTKEY_FEEDBACK_EVENT, { detail }),
  );
}
